import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import SortByAlert from '@components/modal/SortByAlert'
import { RadioOption } from '@components/radio/Radio'
import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'

interface Props {
  reverse: boolean
  onOrderChange?: (val: boolean) => void
  sort?: RadioOption
  onSortChange: (val?: RadioOption) => void
  sorts: RadioOption[]
  title?: string
  color?: string
}

const SortSelector = ({
  reverse,
  onOrderChange,
  sort,
  onSortChange,
  sorts,
  title,
  color = theme.colors.primary,
}: Props) => {
  const i18n = useI18n()

  const openSortModal = () => {
    SortByAlert.open({ data: sorts, onChange: onSortChange, initValue: sort })
  }

  return (
    <SortContainer>
      <TouchableOpacity activeOpacity={0.9} onPress={openSortModal}>
        <SortText>
          {title === undefined ? i18n.t('components.incidentListSection.sortBy') : title}
          <SortValue color={color}>{sort ? sort.label : sorts[0].label}</SortValue>
        </SortText>
      </TouchableOpacity>
      {!!onOrderChange && (
        <TouchableOpacity activeOpacity={0.9} onPress={() => onOrderChange(!reverse)}>
          <Icon name={reverse ? 'arrow-up' : 'arrow-down'} size={24} color={theme.colors.primary} />
        </TouchableOpacity>
      )}
    </SortContainer>
  )
}

export default SortSelector

const SortContainer = styled(View)`
  flex-direction: row;
  align-items: center;
`

const SortText = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
`
const SortValue = styled(Text)<{ color: string }>`
  color: ${(props) => props.color};
`
